import escapeRegExp from 'lodash/escapeRegExp';

export const createFilterRegex = (value: string): RegExp => new RegExp(escapeRegExp(value.trim()), 'i');

export const stripNonDigits = (value: string): string => value.replace(/\D/g, '');
